import { Component, FC, useEffect, useState } from 'react';
import { HeaderWrapper } from '../../../_metronic/layout/components/header';
import { createRoot } from 'react-dom/client';
import './Dashboard.css'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Card from 'react-bootstrap/Card';
import ReactPlayer from 'react-player';
import { Get } from '../../services/DashboardService';
import { DashboardModel } from '../../models/DashboardModel';

const responsiveContents = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 767, min: 464 },
    items: 1,
  }
};

const responsiveNews = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 767, min: 464 },
    items: 1,
  }
};

const responsiveAwards = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5,
    slidesToSlide: 5 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 3,
    slidesToSlide: 3 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 767, min: 464 },
    items: 2,
    slidesToSlide: 1 // optional, default to 1.
  }
};

const sliderNews = [
  {
    index: 1,
    title: "Aktif duyuru bulunmamaktadır.",
    text: ''
  },
];

const sliderContents = [
  {
    index: 1,
    url: "https://akademi-admin.vestel.com.tr/videos/vta.mp4",
    title: "Teknoloji Akademisi",
    text: "Vestel çalışanları Teknoloji Akademisi ile yükseköğrenimlerine devam ediyor."
  },
  {
    index: 2,
    url: "https://akademi-admin.vestel.com.tr/videos/icegitmenlik.mp4",
    title: "İç Eğitmenlik",
    text: "Vestel'in ilk iç eğitmenleri eğitim vermeye başladı."
  },
  {
    index: 3,
    url: "https://akademi-admin.vestel.com.tr/videos/atolyeliderlik.mp4",
    title: "Atölye Liderlik Okulu",
    text: "Atölye Liderlik Okulu ekip ve vardiya liderlerinin yönetsel yetkinliklerini geliştirmeye devam ediyor."
  },
  {
    index: 4,
    url: "https://akademi-admin.vestel.com.tr/videos/14mtegitim.mp4",
    title: "Management Trainee",
    text: "14. MT Eğitim Programı tamamlandı."
  }
];

const sliderAwards = [
  {
    index: 1,
    src: "/media/logos/TEGEP2.png",
    alt: 'TEGEP2'
  },
  {
    index: 2,
    src: "/media/logos/STEVIE.png",
    alt: 'STEVIE'
  },
  {
    index: 3,
    src: "/media/logos/TEGEP.png",
    alt: 'TEGEP'
  },
  {
    index: 4,
    src: "/media/logos/brandonHall.png",
    alt: 'brandonHall'
  },
  {
    index: 5,
    src: "/media/logos/PERYON.png",
    alt: 'PERYON'
  }
];

class DashboardWrapper extends Component {
  componentDidMount() {
    createRoot(document.getElementById('masterHeader')!).render(<HeaderWrapper title='Ana Sayfa' isBackIconVisible={false} />);
    createRoot(document.getElementById('subHeader')!).unmount();
    createRoot(document.getElementById('pageHeader')!).unmount();
  }

  render() {
    return (
      <>

      </>
    );
  }
}

const turkishNumberFormat = new Intl.NumberFormat('tr-TR', {
  style: 'decimal',
  maximumFractionDigits: 0
});


const DashboardWrapperPage: FC = () => {
  const [data, setData] = useState<DashboardModel>({ totalDuration: 0, totalParticipant: 0, totalTraining: 0, totalTrainer: 0 });

  useEffect(() => {
    document.getElementById('kt_app_content_container')!.style.backgroundColor = "#F8F9FF";
  }, []);

  useEffect(() => {
    document.getElementById('kt_app_content_container')!.style.backgroundColor = "#FFF";
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    Get().then(function (response) {
      if (response.status === 200) {
        setData(response.data);
      }
    });
  }, []);

  return (
    <>
      <DashboardWrapper></DashboardWrapper>

      <div className='container dashboard-container p-10 pt-1'>
        <div className='row mb-10'>
          <div className='col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 d-flex'>
            <div className='text-left d-flex align-items-center'>
              <img
                alt='Logo '
                src={('/media/logos/vizyon2.png')}
                className='img-fluid col-12 dashboard-card-image p-5'
              />
            </div>
          </div>

          <div className='col-xl-7 col-lg-7 col-md-12 col-sm-12 col-xs-12 mt-12'>
            <div className='row'>
              <div className="col-6 pe-4 d-flex justify-content-center">
                <div className="dashboard-card col-12">
                  <div className="justify-content-center col-3">
                    <img alt='' src='/media/icons/educationHours.svg' />
                  </div>
                  <div className="dashboard-card-body ps-4">
                    <div className="dashboard-card-title mb-2">Eğitim Saati</div>
                    <div className="dashboard-card-text"><b>{turkishNumberFormat.format(data.totalDuration / 60)}+</b></div>
                  </div>
                </div>
              </div>
              <div className="col-6 ps-4 d-flex justify-content-start ">
                <div className="dashboard-card col-12">
                  <div className="justify-content-center col-3">
                    <img alt='' src='/media/icons/attendee.svg' />
                  </div>
                  <div className="dashboard-card-body ps-4">
                    <div className="dashboard-card-title mb-2">Katılımcı</div>
                    <div className="dashboard-card-text"><b>{turkishNumberFormat.format(data.totalParticipant)}+</b></div>
                  </div>
                </div>
              </div>
            </div>
            <div className='row mt-8'>
              <div className="col-6 pe-4 d-flex justify-content-center">
                <div className="dashboard-card col-12">
                  <div className="justify-content-center col-3">
                    <img alt='' src='/media/icons/education.svg' />
                  </div>
                  <div className="dashboard-card-body ps-4">
                    <div className="dashboard-card-title mb-2">Eğitim</div>
                    <div className="dashboard-card-text"><b>{turkishNumberFormat.format(data.totalTraining)}+</b></div>
                  </div>
                </div>
              </div>
              <div className="col-6 ps-4 d-flex justify-content-start">
                <div className="dashboard-card col-12">
                  <div className="justify-content-center col-3">
                    <img alt='' src='/media/icons/trainer.svg' />
                  </div>
                  <div className="dashboard-card-body ps-4">
                    <div className="dashboard-card-title mb-2">Eğitmen</div>
                    <div className="dashboard-card-text"><b>{turkishNumberFormat.format(data.totalTrainer)}+</b></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='row dashboard-news bg-white rounded'>
          <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 pt-14 ps-10'>
            <h1 className='display-6'>Bizden Haberler</h1>
          </div>
          <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3'>
            <div className='dashboard-news-card rounded pe-4'>
              <Carousel
                responsive={responsiveNews}
                autoPlay={false}
                swipeable={true}
                draggable={true}
                showDots={false}
                infinite={false}
                partialVisible={false}
              >
                {sliderNews.map((news) => {
                  return (
                    <div key={news.index} className='text-center'>
                      <h2>{news.title}</h2>
                      <label>{news.text}</label>
                    </div>
                  );
                })}
              </Carousel>
            </div>
          </div>

        </div>

        <div className='links row mb-10'>
          <div className='col-12 text-center mt-10 mb-10'>
            <h1 className='display-6 videos-title'>Göz Atabileceğin İçerikler</h1>
          </div>
          <div className='col-12 text-start'>
            <Carousel
              responsive={responsiveContents}
              autoPlay={false}
              swipeable={true}
              draggable={true}
              showDots={false}
              infinite={false}
              partialVisible={false}
            >
              {sliderContents.map((content) => {
                return (
                  <Card key={content.index} className='link-card rounded shadow-sm ms-2 me-2' style={{ height: 480 }}>
                    <div className='link-image'>
                      <ReactPlayer
                        url={content.url}
                        controls={true}
                        pip={true}
                        width={"100%"}
                        className=''
                      />
                    </div>
                    <Card.Body className='link-body'>
                      <Card.Title className='text-dark'><b>{content.title}</b></Card.Title>
                      <Card.Text className='link-content text-start'>
                        {content.text}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                );
              })}
            </Carousel>
          </div>
        </div>

        <div className='links mb-10'>
          <div className='row'>
            <div className='col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 pt-14 ps-8'>
              <div>
                <h1 className='display-6 links-title'>Faydalı Linkler</h1>
              </div>
              <label className=''> Sizin için faydalı olacak diğer platformlarımıza göz atabilirsiniz.</label>
            </div>

            <div className='col-xl-7 col-lg-7 col-md-12 col-sm-12 col-xs-12'>
              <div className='row'>
                <div className="col-6 pe-4">
                  <div className="dashboard-card col-12 justify-content-start d-flex bg-white rounded shadow-sm p-4">
                    <div className="d-flex items-center justify-content-center col-3">
                      <a href='https://vestelakademi.vestel.com.tr/tr/user-login' className='d-block rounded' title="Gitmek için tıklayınız">
                        <i className="bi bi-link-45deg"></i>
                      </a>
                    </div>
                    <div className="dashboard-card-body d-flex justify-center items-center ps-4 ">
                      <img
                        alt='VestelAkademiMikro'
                        src={('/media/logos/VestelAkademiMikro.png')}
                        className='img-fluid dashboard-links-icons'
                      />
                    </div>
                  </div>
                </div>
                <div className="col-6 ps-4">
                  <div className="dashboard-card col-12 justify-content-start d-flex bg-white rounded shadow-sm p-4">
                    <div className="d-flex items-center justify-content-center col-3">
                      <a href='https://bursiyer.mzv.org.tr/vestel/employeeLogin' className='d-block rounded' title="Gitmek için tıklayınız">
                        <i className="bi bi-link-45deg"></i>
                      </a>
                    </div>
                    <div className="dashboard-card-body d-flex justify-center items-center ps-4">
                      <img
                        alt='MZV'
                        src={('/media/logos/MZV.png')}
                        className='img-fluid dashboard-links-icons'
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className='row mt-8'>
                <div className="col-6 pe-4">
                  <div className="dashboard-card col-12 justify-content-start d-flex bg-white rounded shadow-sm p-4">
                    <div className="d-flex items-center justify-content-center col-3">
                      <a href='https://zorluakademi.zorlu.com/zorluakademi' className='d-block rounded' title="Gitmek için tıklayınız">
                        <i className="bi bi-link-45deg"></i>
                      </a>
                    </div>
                    <div className="dashboard-card-body d-flex justify-center items-center ps-4">
                      <img
                        alt='ZorluAkademi'
                        src={('/media/logos/ZorluAkademi.png')}
                        className='img-fluid dashboard-links-icons'
                      />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div className='awards row'>
          <div className='col-12 pb-10 text-center'>
            <h1 className='display-6'>Ödüllerimiz</h1>
          </div>

          <Carousel
            responsive={responsiveAwards}
            autoPlay={false}
            swipeable={true}
            draggable={true}
            showDots={false}
            infinite={false}
            partialVisible={false}
          >
            {sliderAwards.map((award) => {
              return (
                <div className="justify-content-center shadow-sm" key={award.index}>
                  <div className="slider bg-white rounded p-2">
                    <img src={award.src} alt={award.alt} />
                  </div>
                </div>
              );
            })}
          </Carousel>
        </div>
      </div>
    </>
  )
}
export default DashboardWrapperPage;